<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    componentData: {
      type: Array,
      default: null,
    },
    inputType: {
      type: String,
      default: 'text',
    },
    isPrice: {
      default: false,
      type: Boolean,
    },
    minlength: {
      type: Number,
    },
    maxlength: {
      type: Number,
      default: 50,
    },
    id: {
      type: String,
    },
    classes: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    errortext: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputs: {
        input1: [],
        input2: [],
        input3: [],
        input4: [],
      },
      options: [
        { value: 'ب', text: 'ب' },
        { value: 'ج', text: 'ج' },
        { value: 'د', text: 'د' },
        { value: 'ژ', text: 'ژ' },
        { value: 'س', text: 'س' },
        { value: 'ص', text: 'ص' },
        { value: 'ط', text: 'ط' },
        { value: 'ع', text: 'ع' },
        { value: 'ق', text: 'ق' },
        { value: 'ل', text: 'ل' },
        { value: 'م', text: 'م' },
        { value: 'ن', text: 'ن' },
        { value: 'و', text: 'و' },
        { value: 'ه', text: 'ه' },
        { value: 'ی', text: 'ی' },
      ],
    }
  },
  created() {
    if (this.componentData.length > 0) {
      this.inputs.input1 = this.componentData.slice(0, 2)
      this.inputs.input2 = this.componentData.slice(3, 4)
      this.inputs.input3 = this.componentData.slice(5, 8)
      this.inputs.input4 = this.componentData.slice(9, 11)
    }
  },
  watch: {
    inputs: {
      deep: true,
      handler() {
        if (this.inputs.input1.length > 0 && this.inputs.input2.length > 0 && this.inputs.input3.length > 0 && this.inputs.input4.length > 0) {
          let myData = `${this.inputs.input1}-${this.inputs.input2}-${this.inputs.input3}-${this.inputs.input4}`
          this.$emit('plaque', myData)
        }
      },
    },
  },
}
</script>

<template>
  <div>
    <div class="mainInput container-fluid gx-3" :class="classes">
      <div v-if="title != ''" :class="labelClass" class="labelStyle" :style="title.length > 12 ? `whiteSpace: nowrap; font-size: 12px` : { whiteSpace: 'none' }">{{ title }}</div>
      <div class="plate-style row">
        <input
          maxlength="2"
          v-model="inputs.input1"
          type="number"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          class="inputStyle col-3"
        />
        <b-form-select v-model="inputs.input2" :options="options" class="col-2"></b-form-select>
        <input
          maxlength="3"
          v-model="inputs.input3"
          type="number"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          class="inputStyle col-3"
        />
        <input
          maxlength="2"
          v-model="inputs.input4"
          type="number"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          class="inputStyle col-3"
        />
        <div class="iran">ایران</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .custom-select {
  color: #74788d;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  text-align: center;
  direction: ltr;
  outline: none;
}
.mainInput {
  display: flex;
  align-items: center;
}
.plate-style {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  // max-width: 50%;
}
.inputStyle {
  color: #74788d;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  text-align: center;
  direction: ltr;
}
.inputStyle:last-of-type {
  margin: 0 !important;
  text-align: left;
}
.disableInput {
  width: 100%;
  color: #c6cbd0;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  box-sizing: border-box;
}
input:focus {
  outline: none;
}
input:focus::placeholder {
  color: transparent;
}
.iran {
  position: absolute;
  right: 117px;
  top: 8px;
  width: 20px;
  padding: 0;
}
.errorStyle {
  line-height: 17px;
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #fe5e61;
  padding: 6px 10px;
  box-sizing: border-box;
}
.errorClass {
  position: absolute;
  bottom: -16px;
  font-size: 10px;
  color: #fe5e61;
}
.labelStyle {
  min-width: 90px;
  max-width: 90px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
::v-deep .gx-3 {
  --bs-gutter-x: 12px !important;
}
</style>
